@if (routeState()?.appBaseRoute; as appBaseRoute) {
    @if (!goToMainContentExcluded.includes(appBaseRoute)) {
        <button
            class="absolute! -top-40 left-0 z-50 focus:translate-x-4 focus:translate-y-44"
            id="skip-link-button-main-content"
            interacta-button
            type="button"
            [label]="
                'SKIP_BUTTONS.ACCESSIBILITY.GO_TO_MAIN_CONTENT' | translate
            "
            [style]="'filled'"
            (click)="setFocus('main-content')"
        ></button>
        @if (!goToSidebarExcluded.includes(appBaseRoute)) {
            <button
                class="absolute! -top-40 left-0 z-50 focus:translate-x-12 focus:translate-y-44"
                interacta-button
                type="button"
                [label]="'SKIP_BUTTONS.ACCESSIBILITY.GO_TO_SIDEBAR' | translate"
                [style]="'filled'"
                (click)="setFocus('sidebar')"
            ></button>
        }
    }
}
